import createModel, { prop } from './lib/create_model';

const FunctionCall = createModel({
  modelName: 'FunctionCall',

  properties: {
    id: prop(String),
    name: prop(String),
    arguments: prop(Object),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

const FunctionResult = createModel({
  modelName: 'FunctionResult',

  properties: {
    callId: prop(String),
    output: prop(String),
    skipped: prop(Boolean),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

const AIFunctionCallResults = createModel({
  modelName: 'AIFunctionCallResults',

  properties: {
    calls: prop([FunctionCall]),
    results: prop([FunctionResult]),
    isSkipped: prop(Boolean),
    causedByItemIDs: prop([String]),
    guideType: prop(String),
    guideId: prop(String),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default AIFunctionCallResults;
